<style lang="scss" scoped></style>

<template>
  <td>
    <v-button
      @click.native="navigate()"
      class="btn-primary"
      :disabled="isDeleted"
    >
      {{ label || "Ändern" }}
    </v-button>
  </td>
</template>

<script lang="babel">
export default {
    props: ['content', 'label', 'model'],
    methods: {
      navigate() {
        this.$router.push({ path: new URL(this.content).pathname });
      }
    },
    computed: {
      isDeleted() {
        return Boolean(this.model.deleted_at);
      }
    }
};
</script>
